export default "__VITE_ASSET__e34a57d9__"